import { render, staticRenderFns } from "./WalletHistory.vue?vue&type=template&id=7ae370c0&"
import script from "./WalletHistory.vue?vue&type=script&lang=js&"
export * from "./WalletHistory.vue?vue&type=script&lang=js&"
import style0 from "./WalletHistory.vue?vue&type=style&index=0&id=7ae370c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports